
import { mapGetters } from 'vuex';

export default {
    name: 'FooterUniplast',
    data() {
        return {
            activeSectionId: null
        };
    },
    components: {
        FooterCopyright: () => import('./FooterCopyright'),
        FooterColumn: () => import('./FooterColumn'),
        FooterLogo: () => import('./FooterLogo')
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            footerSettings: 'footer/footerSettings',
            isUniplast: 'global/getIsUniPlast'
        }),
        footerColumns() {
            let firstId = this.footerSettings?.columns[0]?.id;
            const workingTimeAndPhonesColumn = {
                id: ++firstId,
                name: this.$t('workHours'),
                items: [
                    {
                        id: 1,
                        name: this.footerSettings?.workingTime?.workingTimeWeekday
                    },
                    {
                        id: 2,
                        name: this.footerSettings?.workingTime?.workingTimeWeekends
                    },
                    {
                        id: 3,
                        name: this.globalSettings?.phones?.mainPhoneNumber
                    },
                    {
                        id: 4,
                        name: this.globalSettings?.phones?.serviceCenterPhoneNumber
                    },
                    {
                        id: 5,
                        name: this.globalSettings?.phones?.stationaryPhoneNumber
                    },
                    {
                        id: 6,
                        name: this.globalSettings?.phones?.supportPhoneNumber
                    }
                ]
            };

            const addressAndEmailColumn = {
                id: ++firstId,
                name: this.$t('storeAddress'),
                items: [
                    {
                        id: 1,
                        name: this.footerSettings?.issuanceOfOnlineOrders
                    }
                    // напиши ниже код если есть поле this.globalSettings?.email то добавляем еще 2 элемента если нет, то ничего не добавляем
                ]
            };

            if (this.globalSettings?.email || this.isUniplast) {
                addressAndEmailColumn.items.push(
                    {
                        id: 2,
                        name: this.globalSettings?.email || 'info@uniplast.md'
                    },
                    {
                        id: 3,
                        name: this.globalSettings?.email || 'sales@uniplast.md'
                    }
                );
            }

            const array = [workingTimeAndPhonesColumn];

            if (this.footerSettings?.issuanceOfOnlineOrders) {
                array.push(addressAndEmailColumn);
            }

            return this.footerSettings?.columns.reduce((acc, item, index, arr) => {
                if (index === 1 || arr?.length === 1) {
                    acc.push(...array);
                }

                acc.push({
                    ...item,
                    id: index === 0 ? item.id : item.id + array.length
                });
                return acc;
            }, []);
        }
    },
    methods: {
        toggleSection(sectionId) {
            this.activeSectionId = this.activeSectionId === sectionId ? null : sectionId;
        }
    }
};
